import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import moment from 'moment';

import { getJobsByDealer } from '../../store/actions';
import { sortText } from '../../utils/sortHelper';

import BaseTable from '../BaseTable';

import './index.css';

const tableOptions = {
  columns: [
    {
      name: "Status",
      dataKey: 'status',
      type: 'select',
      isSortable: true,
      isSelectColored: true,
      isReadOnly: true,
      selectOptions: [
        {'In progress': '#219653'},
        {'Scheduled': '#2D9CDB'},
        {'Completed': '#F2994A'},
        {'Canceled': '#EB5757'}
      ]
    },
    { 
      name: "Scheduled",
      dataKey: 'scheduledStartTime',
      type: 'date',
      isSortable: true,
    },
    { 
      name: "Name",
      dataKey: 'name',
      type: 'text',
      isSortable: true,
    },
    { 
      name: "Number",
      dataKey: 'UUID',
      type: 'id',
      isSortable: true,
    },
    { 
      name: "Team",
      dataKey: 'countAssignedUsers',
      type: 'text-postfix',
      postfix: 'employee',
      isSortable: true,
    },
    {
      name: 'Notes',
      dataKey: 'notes',
      type: 'notes',
      isSortable: false
    },
    { 
      name: "Reports",
      type: 'default-link',
      isConditional: true,
      dataKey: 'reportLink',
      label: 'Download',
      isSortable: false
    }
  ]
}

const DealerJobList = (props) => {
  const [localJobs, setLocalJobs] = useState(props.jobsByDealer[props.dealer.UUID] ? [...props.jobsByDealer[props.dealer.UUID]] : []);
  const [jobSort, setJobSort] = useState({isDesc: false, prop: ''});

  useEffect(() => {
    !props.jobsByDealer[props.dealer.UUID] && props.getJobsByDealer(props.dealer);
  }, []);

  useEffect(() => {
    const jobs = props.jobsByDealer[props.dealer.UUID];
    setLocalJobs(jobs ? [...jobs] : []);
  }, [props.jobsByDealer])

  const sortTable = ({dataKey}) => {
    setJobSort({
      isDesc: jobSort.prop === dataKey ? !jobSort.isDesc : false,
      prop: dataKey
    });
  }

  useEffect(() => {
    const {prop, isDesc} = jobSort;
    let sorted;
    if (prop === 'scheduledStartTime') {
      sorted = [...localJobs].sort((a, b) => {
        const diff = moment(a[prop], 'YYYY-MM-DD HH:mm:ss') - moment(b[prop], 'YYYY-MM-DD HH:mm:ss');
        return isDesc ? diff : diff * -1;
      });
    } else {
      sorted = [...localJobs].sort(sortText(prop, isDesc));
    }
  setLocalJobs(sorted);
  }, [jobSort])

  const rowOnClick = (id) => {
    props.history.push(`/jobs/${id}`)
  }

  return (
      <BaseTable 
        className="dealer-jobs__table" 
        onSort={sortTable} 
        options={tableOptions} 
        data={localJobs}
        rowOnClick={rowOnClick}
      />
  );
}

const mapStateToProps = ({dealers: {jobsByDealer}}) => ({jobsByDealer});

export default connect(mapStateToProps, { getJobsByDealer })(withRouter(DealerJobList));